export default {
  mode: {
    light: "Claro",
    dark: "Oscuro"
  },
  
  guide: {
    title: "Guía de Tema"
  },
  
  colors: {
    title: "Colores",
    primary500: "Primario 500",
    primary600: "Primario 600", 
    primary700: "Primario 700",
    secondary500: "Secundario 500",
    success: "Éxito",
    warning: "Advertencia",
    error: "Error",
    background: "Fondo",
    surface: "Superficie",
    card: "Tarjeta"
  },
  
  typography: {
    title: "Tipografía",
    h1: "Encabezado 1",
    h1Font: "Texto 4xl Serif",
    h2: "Encabezado 2", 
    h2Font: "Texto 3xl Serif",
    h3: "Encabezado 3",
    h3Font: "Texto 2xl Serif",
    body: "Texto del cuerpo",
    bodyFont: "Texto base",
    small: "Texto pequeño",
    smallFont: "Texto sm"
  },
  
  components: {
    title: "Componentes",
    
    buttons: {
      title: "Botones",
      default: "Predeterminado",
      outline: "Contorno",
      secondary: "Secundario", 
      ghost: "Fantasma",
      danger: "Peligro",
      success: "Éxito",
      disabled: "Deshabilitado",
      loading: "Cargando"
    },
    
    form: {
      title: "Elementos de Formulario",
      input: "Campo de Entrada",
      select: "Campo de Selección",
      switch: "Interruptor"
    },
    
    badges: {
      title: "Etiquetas",
      default: "Predeterminado",
      secondary: "Secundario",
      success: "Éxito",
      warning: "Advertencia",
      error: "Error",
      mint: "Menta",
      rose: "Rosa",
      outline: "Contorno"
    },
    
    alerts: {
      title: "Alertas",
      info: {
        title: "Información",
        description: "Esta es una alerta informativa."
      },
      success: {
        title: "Éxito",
        description: "Esta es una alerta de éxito."
      },
      warning: {
        title: "Advertencia", 
        description: "Esta es una alerta de advertencia."
      },
      error: {
        title: "Error",
        description: "Esta es una alerta de error."
      }
    }
  },
  
  code: {
    title: "Ejemplos de Código",
    darkMode: {
      title: "Implementación del Modo Oscuro",
      example: "className=\"bg-white dark:bg-dark-card text-gray-900 dark:text-white\""
    }
  }
} 